module.exports = __webpack_public_path__ + "img/album18_44.f87e8d85.jpg";